import React, { Component } from 'react';
import { TotalFatalInjuryPdoRow } from './common';
import { sortBasedOnList } from '../utils';

export type Table11bData = { [key: string]: Table11bRow };

interface ITable11bProps {
  data: Table11bData;
}

export interface Table11bRow {
  fatal: number;
  injuryA: number;
  injuryB: number;
  injuryC: number;
  pdo: number;
  total: number;
}

interface ITable11bState {
}

const sortOrder = [
  "None (No improper action)",
  "Dart/Dash",
  "Disabled Vehicle-Related (working on, pushing, leaving/approaching)",
  "Distracted Walking/Running/Cycling(texting/talking on, listening to mobile device)",
  "Entering/Exiting Parked/Standing Vehicle",
  "Failure to Obey Traffic Signs, Signals, or Officer",
  "Failure to Yield Right-of-Way",
  "Improper Passing",
  "Improper Turn/Merge",
  "Inattentive (talking, eating, etc)",
  "Not Visible (dark clothing, no lighting, etc)",
  "In Roadway Improperly (standing, lying, playing, working)",
  "Under the Influence of Drugs/Alcohol",
  "Wrong-Way Riding or Walking",
  "Other",
  "Unknown",
  "Not Stated",
];

export default class Table11bSummary extends Component<ITable11bProps, ITable11bState> {

  constructor(props: ITable11bProps) {
    super(props);
    this.state = {
      data: null
    }
  }

  componentDidMount = function () {
  }

  render() {
    return (
      this.props.data ?
        <table className="ss-table summaryTable1">
          <colgroup>
            <col style={{ width: 800 }} />
          </colgroup>
          <thead>
            <tr>
              <th rowSpan={2} className="border-right-bold">
                <div className="ss-table-header">
                  <span className="header-number">11b</span>
                  <span className="header-text">
                    <div>NON MOTORIST ACTIONS</div>
                    <small>Up to 4 actions per non-motorist</small>
                  </span>
                </div>
              </th>
              <th rowSpan={2}>TOTAL</th>
              <th rowSpan={2}>FATAL</th>
              <th colSpan={3}>INJURY</th>
              <th rowSpan={2}>PDO **</th>
            </tr>
            <tr>
              <th>A*</th>
              <th>B*</th>
              <th>C*</th>
            </tr>
          </thead>
          <tbody>
            {sortBasedOnList(this.props.data, sortOrder).map((key) =>
              <tr key={key}>
                <td className="border-right-bold">{key}</td>
                <td className="numberTotals">{this.props.data[key].total}</td>
                <td className="numberTotals">{this.props.data[key].fatal}</td>
                <td className="numberTotals">{this.props.data[key].injuryA}</td>
                <td className="numberTotals">{this.props.data[key].injuryB}</td>
                <td className="numberTotals">{this.props.data[key].injuryC}</td>
                <td className="numberTotals">{this.props.data[key].pdo}</td>
              </tr>
            )}
          </tbody>
        </table>
        : <p>Loading...</p>
    );
  }
}
